import { ui } from '!/skin'

PartnerProgramDetailsPage.displayName = 'PartnerProgramDetailsPage'
export function PartnerProgramDetailsPage(): JSX.Element {
  return (
    <ui.PageWrapper>
      <ui.RenderSkin name='partnerProgramDetails' />
    </ui.PageWrapper>
  )
}
